'use strict';

var KeyMirror = require('keymirror');
var ProductIds = require('./ApplicationConstants').ProductIds;

var _downloadableForms = {};

_downloadableForms['application'] = [
	{ value: 'appForm', group: 'Opening your account' } //Application Form
];
_downloadableForms[ProductIds.SUPER] = [
    { value: 'consolidate', group: 'Funding your account' }, //Consolidating your super (FirstChoice Wholesale Personal Super)
    { value: 'superChoice', group: 'Funding your account' }, //Colonial First State - Super Choice Fund Nomination Form
    { value: 'dda2', group: 'Funding your account' }, //Colonial First State Direct Debit Authority Form
    { value: 'noticeOfIntent', group: 'Managing your account' }, //Notice of intent to claim tax deduction
    { value: 'bindingDeath', group: 'Managing your account' }, //Non lapsing death benefit nomination form
    { value: 'onlineAdviserInd2', group: 'Managing your account' }, //Colonial First State Adviser Online Transaction Authority - Individual
    { value: 'specSign', group: 'Managing your account' }, //Specimen Signature Form
    { value: 'individualKyc', group: 'Managing your account' }, //Identification Form Individuals and Sole Traders
    { value: 'rolloverInternal', group: 'Insurance' }, //FirstChoice Rollover of Insurance Cover Form (Internal)
    { value: 'insuranceApp', group: 'Insurance' } //Insurance application
];
_downloadableForms[ProductIds.PENSION] = [
	{ value: 'consolidate', group: 'Funding your account' }, //Consolidating your super (FirstChoice Wholesale Personal Super)
    { value: 'dda2', group: 'Funding your account' }, //Colonial First State Direct Debit Authority Form
    { value: 'noticeOfIntent', group: 'Managing your account' }, //Notice of intent to claim tax deduction
    { value: 'tfnDeclaration', group: 'Managing your account'}, //TFN Declaration Form
    { value: 'bindingDeath', group: 'Managing your account' }, //Non lapsing death benefit nomination form
    { value: 'onlineAdviserInd2', group: 'Managing your account' }, //Colonial First State Adviser Online Transaction Authority - Individual
    { value: 'specSign', group: 'Managing your account' }, //Specimen Signature Form
    { value: 'individualKyc', group: 'Managing your account' } //Identification Form Individuals and Sole Traders
]
_downloadableForms[ProductIds.INVESTMENT] = [
    { value: 'dda2' }, //Colonial First State Direct Debit Authority Form
    { value: 'dda5' }, //Colonial First State Direct Debit Authority Form
    { value: 'onlineAdviserInd2'}, //Colonial First State Adviser Online Transaction Authority - Individual
    { value: 'individualKyc' }, //Identification Form Individuals and Sole Traders
    { value: 'partnershipKyc' }, //Identification form Partnerships
    { value: 'smsfKyc' }, //Identification form - Regulated Trusts and Trustees (Including Self Manged Super Funds)
    { value: 'companyKyc' }, //Identification form - Foreign Companies
    { value: 'trustKyc' }, //Identification form Regulated and Unregulated trust
    { value: 'auCompanyKyc' }, //Identification form - Australian Companies
    { value: 'onlineAdviserInd5' }, //Colonial First State Adviser Online Transaction Authority - Individual
    { value: 'onlineAdviserOrg5' }, //Colonial First State Adviser Online Transaction Authority - Organisation
    { value: 'onlineAdviserOrg2' }, //Colonial First State Adviser Online Transaction Authority - Organisation
    { value: 'specSign', group: 'Managing your account' } //Specimen Signature Form
]

module.exports = {
    userTypes: ['P', 'I', 'A'],
    investorModel: {
		name: '',
		oin: ''
	},
	downloadId: {
		accountConfirmation: 'welcomeLetter',
		checklist: 'coverLetter',
		applicationForm: 'applicationFormDownload'
	},
	ActionTypes: KeyMirror({
		DOWNLOAD_ALL: null,
		RESPONSE_DOWNLOAD_ALL: null,
        DOWNLOAD_FORM_SUCCESS: null,
        DOWNLOAD_FORM_FAILED: null
	}),
	downloadableForms: _downloadableForms,
	formGroups: ['Funding your account', 'Managing your account', 'Insurance'],
	applicationGroup: 'Opening your account',
    additionalInvestorForm: { value: 'appAdditionalInvestor', group: 'Opening your account' }
};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./constants/CongratulationsConstants.js